const wrapWithProvider = require('./wrap-with-provider').default;

exports.wrapRootElement = wrapWithProvider;
